import React from 'react';

// import { Container } from './styles';

function LegalVideos() {
  return (
    <div>
      <p className="body-title mt-4 mb-3">Vídeos #JURÍDICO - PROCESSOS</p>
      <iframe
        width="800"
        height="450"
        src="https://www.youtube.com/embed/videoseries?list=PLAQjx6GeNW4j4Tz8DAd1CGxatPFHOKwLN"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  );
}

export default LegalVideos;
